// extracted by mini-css-extract-plugin
export default {"inicio":"PageInicio_inicio__hgN92"};